import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isNonEmptyString,
  createCustomPropType,
  isNumeric,
} from '../../../../js/app/react/validators';

import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { BACKEND_KEY } from '../PersonalInfoWorkflowConstants';
import YesOrNoCheckbox from '../../YesOrNoCheckbox/YesOrNoCheckboxView';
import { validateAreYouMarried, isPersonalInfoValid } from '../PersonalInfoWorkflowValidator';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';
import areYouMarriedShouldSkip, { localStorageKey } from './AreYouMarriedShouldSkip';

class AreYouMarriedView extends Component {
  componentDidUpdate({ isPopulated: previousIsPopulated }) {
    const {
      clientId, partner, isPopulated, store2, workflowId,
    } = this.props;

    if (!previousIsPopulated && isPopulated && partner) {
      store2(workflowId)(
        {
          [BACKEND_KEY]: {
            HasPartner: true,
            AlreadyHadPartnerData: true,
          },
        },
        clientId,
      );
    }
  }

  render() {
    const {
      branch,
      workflowId,
      clientId,
      hasPartner,
      store,
      store2,
      hasPartnerClicked,
      alreadyHadPartnerData,
      isGoingForward,
      personalInfo,
      nextIterators,
      onPostProcess,
      onPostSave,
      dirtyGraphNodes,
    } = this.props;
    return (
      <AdvWorkflowStep
        branch={branch}
        workflowId={workflowId}
        canSkip={areYouMarriedShouldSkip(isGoingForward, alreadyHadPartnerData, clientId)}
        id="AreYouMarried"
      >
        <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.AreYouMarried`} />
        <h2>Do you have a partner?</h2>
        <YesOrNoCheckbox
          checked={hasPartner}
          onClick={hasPartnerClicked(clientId, store(workflowId), store2(workflowId))}
        />
        <Navigation
          nextIterators={nextIterators}
          validator={validateAreYouMarried(hasPartner)}
          validationId={`${BACKEND_KEY}.AreYouMarried`}
          workflowId={workflowId}
          doNotSave={!isPersonalInfoValid(hasPartner, personalInfo)}
          backendKey={BACKEND_KEY}
          validatedOnClick={() => {
            workflowAnalyticsEvents(workflowId, 'retirement_marriage_completed');
            localStorage.setItem(localStorageKey(clientId), true);
          }}
          onPostProcess={onPostProcess(hasPartner)}
          onPostSave={onPostSave(workflowId)}
          dirtyGraphNodes={dirtyGraphNodes}
        />
      </AdvWorkflowStep>
    );
  }
}

AreYouMarriedView.defaultProps = {
  hasPartner: null,
};

AreYouMarriedView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  store2: PropTypes.func.isRequired,
  store: PropTypes.func.isRequired,
  isPopulated: PropTypes.bool.isRequired,
  hasPartner: PropTypes.bool,
  partner: PropTypes.shape({}).isRequired,
  hasPartnerClicked: PropTypes.func.isRequired,
  alreadyHadPartnerData: PropTypes.bool.isRequired,
  isGoingForward: PropTypes.bool.isRequired,
  personalInfo: PropTypes.shape({}).isRequired,
  onPostProcess: PropTypes.func.isRequired,
  onPostSave: PropTypes.func.isRequired,
  nextIterators: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  dirtyGraphNodes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
};

export default AreYouMarriedView;
